<script>
import BaseFilter from "./single-field-filter";

export default {
  extends: BaseFilter,

  props: {
    options: {
      type: Array,
      default: () => ([]),
    },
    optionKey: {
      type: String,
      default: 'value',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    optionLabel: {
      type: String,
      default: 'label',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    reserveKeyword: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    /**
     * @return {Object}
     */
    getOptionBy(value) {
      return _.find(this.options, {[this.optionValue]: value});
    },

    /**
     * @param {*} value
     * @param {Number} index
     * @return {string}
     */
    buildLabelContent(value, index = null) {
      return _.get(this.getOptionBy(value), this.optionLabel, String(value));
    },
  },
}
</script>
